module.exports = __webpack_public_path__ + "img/nl-NL-add-to-google-wallet.861f9e2.svg";